import type { BadgeVariant } from "../common/Badge";

export function statusVariant(status: string | null | undefined): BadgeVariant {
  const normalized = (status ?? "").toLowerCase();
  if (!normalized) {
    return "default";
  }
  if (
    normalized.includes("done") ||
    normalized.includes("complete") ||
    normalized.includes("closed")
  ) {
    return "success";
  }
  if (normalized.includes("blocked") || normalized.includes("fail")) {
    return "danger";
  }
  if (normalized.includes("progress") || normalized.includes("doing")) {
    return "info";
  }
  if (normalized.includes("todo") || normalized.includes("backlog")) {
    return "default";
  }
  return "default";
}

export function riskVariant(risk: string | null | undefined): BadgeVariant {
  const normalized = (risk ?? "").toLowerCase();
  if (!normalized) {
    return "default";
  }
  if (normalized === "high") {
    return "danger";
  }
  if (normalized === "medium") {
    return "warning";
  }
  if (normalized === "low") {
    return "success";
  }
  return "default";
}
